// ** React Imports
import { Fragment, useState, useEffect } from "react";
import { useQuery } from "react-apollo";

// ** Custom Components
import Avatar from "@components/avatar";
import annoucement from "../../../../assets/images/logo/annoucement.svg";
import { GET_ALL_ANNOUNCEMENT } from "./query";

// ** Third Party Components
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";

// ** Reactstrap Imports
import { Button, Badge, DropdownMenu, DropdownItem, DropdownToggle, UncontrolledDropdown } from "reactstrap";

const NotificationDropdown = () => {
    const [announcementData, setAnnouncementData] = useState([]);
    const [notificationsArray, setNotificationsArray] = useState([]);
    const [notificationCount, setNotificationCount] = useState("");

    //query For get announcement
    const { data } = useQuery(GET_ALL_ANNOUNCEMENT, {
        fetchPolicy: "cache-and-network",
    });

    useEffect(() => {
        if (data?.getAllAnnouncement) {
            setAnnouncementData(data?.getAllAnnouncement?.data || []);
            setNotificationCount(data?.getAllAnnouncement?.count);
        }
    }, [data]);

    useEffect(() => {
        if (announcementData) {
            const newData = announcementData?.map((d) => {
                return {
                    img: require("@src/assets/images/avatars/avatar-blank.png").default,
                    subtitle: d?.A_DESCRIPTION,
                    title: (
                        <p className="media-heading">
                            <span className="fw-bolder">{d?.TITLE}</span>
                        </p>
                    ),
                };
            });
            setNotificationsArray(newData);
        }
    }, [announcementData]);

    // ** Function to render Notifications
    /*eslint-disable */
    const renderNotificationItems = () => {
        return (
            <PerfectScrollbar
                component="li"
                className="media-list scrollable-container"
                options={{
                    wheelPropagation: false,
                }}
            >
                {notificationsArray.map((item, index) => {
                    return (
                        <a key={index} className="d-flex" href="/" onClick={(e) => e.preventDefault()}>
                            <div
                                className={classnames("list-item d-flex", {
                                    "align-items-start": !item.switch,
                                    "align-items-center": item.switch,
                                })}
                            >
                                {!item.switch ? (
                                    <Fragment>
                                        <div className="me-1">
                                            <Avatar
                                                {...(item.img
                                                    ? { img: item.img, imgHeight: 32, imgWidth: 32 }
                                                    : item.avatarContent
                                                    ? {
                                                          content: item.avatarContent,
                                                          color: item.color,
                                                      }
                                                    : item.avatarIcon
                                                    ? {
                                                          icon: item.avatarIcon,
                                                          color: item.color,
                                                      }
                                                    : null)}
                                            />
                                        </div>
                                        <div className="list-item-body flex-grow-1">
                                            {item.title}
                                            <small className="notification-text">{item.subtitle}</small>
                                        </div>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        {item.title}
                                        {item.switch}
                                    </Fragment>
                                )}
                            </div>
                        </a>
                    );
                })}
            </PerfectScrollbar>
        );
    };
    /*eslint-enable */

    return (
        <UncontrolledDropdown tag="li" className="dropdown-notification nav-item me-25">
            <DropdownToggle tag="a" className="nav-link" href="/" onClick={(e) => e.preventDefault()}>
                <img src={annoucement} alt="annoucement" className="header-icon-width" />
                {/* <Bell size={21} /> */}
                <Badge pill color="danger" className="badge-up">
                    {notificationCount}
                </Badge>
            </DropdownToggle>
            <DropdownMenu end tag="ul" className="dropdown-menu-media mt-0">
                <li className="dropdown-menu-header">
                    <DropdownItem className="d-flex" tag="div" header>
                        <h4 className="notification-title mb-0 me-auto">Announcements</h4>
                        <Badge tag="div" color="light-primary" pill>
                            {`${notificationCount} New`}
                        </Badge>
                    </DropdownItem>
                </li>
                {renderNotificationItems()}
                <li className="dropdown-menu-footer">
                    <Button color="primary" block>
                        Read all Announcement
                    </Button>
                </li>
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

export default NotificationDropdown;
